var imat = imat || {};

imat.UILayout = {
  init: function($) {
    'use strict';

    //Hamburger Menu
    function ToggleController(args) {
      this.controller = args.controller;
      this.target = args.target;
      this.toggleClass = args.toggleClass;
      this.init();
    }

    ToggleController.prototype = {
      init: function() {
        var vm = this;
        $(document).on('click', '[' + vm.controller + ']', function() {
          $(
            '[' + vm.target + '="' + $(this).attr(vm.controller) + '"]'
          ).toggleClass(vm.toggleClass);
        });
      }
    };

    new ToggleController({
      controller: 'data-toggle-controller',
      target: 'data-toggle-target',
      toggleClass: 'is-active'
    });

    // Device navigation menu control (show/hide submenu for devices)

    function DeviceNavigationMenu(options) {
      this.options = options;
      this.$deviceMenu = options.$deviceMenu;
      this.$deviceMenuContent = options.$deviceMenuContent;
      this.$deviceMenuContentSelector = options.$deviceMenuContentSelector;
      this.isDeviceMenuOpen = false;
      this.initBehaviour();
    }

    DeviceNavigationMenu.prototype = {
      showDeviceMenu: function() {
        this.isDeviceMenuOpen = true;
      },

      closeDeviceMenu: function() {
        this.isDeviceMenuOpen = false;
      },

      showTabContent: function(item) {
        var me = this;

        me.$deviceMenuContent.removeClass('is-active');
        $('.js-device-navigation_tab').removeClass('is-active');
        $(item).addClass('is-active');

        if (item.classList.contains('site-navigation')) {
          $('#deviceSiteNavigation').addClass('is-active');
        } else if (item.classList.contains('account-navigation')) {
          $('#deviceAccountNavigation').addClass('is-active');
        } else if (item.classList.contains('content-navigation')) {
          $('#devicePageNavigation').addClass('is-active');
        }
      },

      showNavAreaContent: function(item) {
        $('.js-device-navigation_item').removeClass('active');
        $(item).addClass('active');
      },

      initBehaviour: function() {
        var me = this;

        $(document).on(
          'click',
          '.js-device-navigation_tab, .js-device-navigation_item',
          function() {
            var item = this;

            if (item.classList.contains('js-device-navigation_tab')) {
              me.showTabContent(item);
            } else {
              me.showNavAreaContent(item);
            }
          }
        );
      }
    };

    new DeviceNavigationMenu({
      $deviceMenu: $('#deviceNavigationMenu'),
      $deviceMenuContent: $('.js-device-navigation_menu'),
      $deviceMenuContentSelector: $('.js-device-navigation_tab')
    });

    // Default navigation menu control (show/hide navigation areas for destop)

    function DefaultNavigationMenu(options) {
      options = options || {};

      this.$navItems = options.$navItems;
      this.$navItemAreaSelector = options.$navItemAreaSelector;
      this.$navArea = options.$navArea;
      this.$areaItems = options.$areaItems;
      this.$closeArea = options.$closeArea;

      this.isNavAreaOpen = false;
      this.$activeMenuItem = 0;

      this.initBehaviour();
    }

    DefaultNavigationMenu.prototype = {
      showNavArea: function(stopAnimation) {
        this.isNavAreaOpen = true;
        this.$navArea.stop(stopAnimation, stopAnimation).slideDown(500);
      },

      hideNavArea: function (stopAnimation) {
        this.isNavAreaOpen = false;
        this.$navArea.stop(stopAnimation, stopAnimation).slideUp(500);
        this.removeActiveState();
      },

      setActiveName: function(activeName) {
        this.hideAllAreaItem();
        this.removeActiveState();

        this.$navArea.find('.' + activeName).fadeIn(500);
        this.$navItemAreaSelector
          .find('.' + activeName)
          .parent()
          .addClass('is-active');
      },

      //Remove class
      removeActiveState: function() {
        this.$navItemAreaSelector.find('.is-active').removeClass('is-active');
      },

      //Hide all!
      hideAllAreaItem: function() {
        this.$areaItems.hide();
      },

      //Check if menu is active
      checkIfActive: function(event) {
        if (
          !this.$activeMenuItem ||
          this.$activeMenuItem != $(event.target).attr('data-nav-area')
        ) {
          return true;
        } else if (
          this.$activeMenuItem ||
          this.$activeMenuItem == $(event.target).attr('data-nav-area')
        ) {
          return false;
        }
      },

      //Get data from data-nav-area
      setActiveArea: function(event) {
        this.$activeMenuItem = $(event.target).attr('data-nav-area') || 0;
      },

      // Check if Click event target is Hyper Link
      isHyperLink: function(target) {
        if (target.tagName === 'A') {
          return true;
        }
        if (target && target.parentNode) {
          return this.isHyperLink(target.parentNode);
        }
        return false;
      },

      //Main Init
      initBehaviour: function() {
        var me = this;

        //Menu item click
        me.$navItems.on('click', function(event) {
          event.stopImmediatePropagation();
          if (me.checkIfActive(event)) {
            me.setActiveArea(event);
            me.setActiveName(me.$activeMenuItem);
            me.showNavArea(true);
          } else if (!me.checkIfActive(event)) {
            me.hideNavArea(true);
            me.setActiveArea(0);
          }
        });

        //Close-button click
        me.$closeArea.on('click', function() {
          me.hideNavArea(false);
          me.setActiveArea(0);
        });

        //Close on click Out of Header and on click on a tag
        $(document).on('click', function(event) {
          if (
            !$(event.target).parents('#header').length ||
            me.isHyperLink(event.target)
          ) {
            me.hideNavArea(false);
            me.setActiveArea(0);
          }
        });

        //Close on scroll
        $(document).on('scroll', function() {
          me.hideNavArea(false);
          me.setActiveArea(0);
        });
      }
    };

    new DefaultNavigationMenu({
      $navItemAreaSelector: $('.js-default-site-navigation'),
      $navItems: $('.js-nav-area-item'),
      $navArea: $('#defaultNavigationAreas'),
      $areaItems: $('.js-default-nav-area'),
      $closeArea: $('#closeDefaultNavigationAreas')
    });

    // Device user menu, upload model button dropdown control (show/hide user menu for devices)

    function DropDownMenu(options) {
      options = options || {};

      this.$defaultAccountMenuToggle = options.$defaultAccountMenuToggle;
      this.$defaultAccountMenu = options.$defaultAccountMenu;

      this.isDefaultAccountMenuOpen = false;

      this.initBehaviour();
    }

    DropDownMenu.prototype = {
      showDefaultAccountMenu: function() {
        this.isDefaultAccountMenuOpen = true;
        this.$defaultAccountMenu.slideDown(200);
      },

      closeDefaultAccountMenu: function() {
        this.isDefaultAccountMenuOpen = false;
        this.$defaultAccountMenu.slideUp(200);
      },

      initBehaviour: function() {
        var me = this;

        this.$defaultAccountMenuToggle.on('click', function() {
          if (!me.isDefaultAccountMenuOpen) {
            me.showDefaultAccountMenu();
          } else {
            me.closeDefaultAccountMenu();
          }
        });
        //Close on click Out of topBar
        $(document).on('click', function(event) {
          if (
            me.$defaultAccountMenuToggle[0] &&
            !$(event.target).parents('#' + me.$defaultAccountMenuToggle[0].id)
              .length
          ) {
            me.closeDefaultAccountMenu();
          }
        });
      }
    };

    new DropDownMenu({
      $defaultAccountMenuToggle: $('#defaultAccountMenuToggle'),
      $defaultAccountMenu: $('#defaultAccountMenu')
    });

    new DropDownMenu({
      $defaultAccountMenuToggle: $('#headerUploadButton'),
      $defaultAccountMenu: $('#headerUploadButton .js-dropdown-menu')
    });

    new DropDownMenu({
      $defaultAccountMenuToggle: $('#deviceUploadButton'),
      $defaultAccountMenu: $('#deviceUploadButton .js-dropdown-menu')
    });

    new DropDownMenu({
      $defaultAccountMenuToggle: $('#headerLanguageSelectorButton'),
      $defaultAccountMenu: $('#headerLanguageSelector')
    });

    new DropDownMenu({
      $defaultAccountMenuToggle: $('#materialsNavigationMenuButton'),
      $defaultAccountMenu: $('#materialsNavigationMenu')
    });

    function getMessageBarHeightIfVisible() {
      var messageBarSelector = $('#messageBar');
      if (messageBarSelector.is(':visible')) {
        return messageBarSelector.height();
      } else {
        return 0;
      }
    }

    // Scroll handlers
    function ScrollHandler(options) {
      this.options = options;
      this.scrollToShowMenu = options.scrollToShowMenu;
      this.scrollSpeed = options.scrollSpeed;
      this.$scrollTopControl = options.$scrollTopControl;
      this.$scrollTopTarget = options.$scrollTopTarget;
      this.$pageAnchor = options.$pageAnchor;
      this.$pageHeader = options.$pageHeader;
      this.$pageWrapper = options.$pageWrapper;
      this.topWrapperHeight = options.topWrapperHeight;
      this.initBehaviour();
    }

    ScrollHandler.prototype = {
      toggleScrollToTopButton: function() {
        var me = this;

        if (me.getWindowScrollFromTop() > me.topWrapperHeight) {
          me.$scrollTopControl.fadeIn();
        } else {
          this.$scrollTopControl.fadeOut();
        }
      },

      animateScroll: function(target) {
        var me = this;

        $('html, body').animate(
          {
            scrollTop: target.offset().top
          },
          me.scrollSpeed
        );
      },

      checkIfApiPages: function() {
        return $('body.web-api').length;
      },

      getHeaderSectionHeight: function() {
        var me = this;
        return me.$scrollTopTarget.height();
      },

      getWindowScrollFromTop: function() {
        return $(window).scrollTop();
      },

      headerBehavior: function() {
        var me = this;

        if (me.checkIfApiPages()) return;

        if (me.getWindowScrollFromTop() >= me.scrollToShowMenu) {
          me.$pageWrapper.css({
            'padding-top': me.getHeaderSectionHeight()
          });
          me.$scrollTopTarget.addClass('shrink');
        } else {
          me.$pageWrapper.css({
            'padding-top': ''
          });
          me.$scrollTopTarget.removeClass('shrink');
        }
      },

      initBehaviour: function() {
        var me = this;
        me.headerBehavior();

        $(window).scroll(function() {
          me.toggleScrollToTopButton();
          me.headerBehavior();
        });

        $(window).resize(function() {
          me.toggleScrollToTopButton();
        });

        me.$scrollTopControl.on('click', function() {
          var target = $('body');
          me.$scrollTopTarget.addClass('hide-header');
          me.animateScroll(target);
          setTimeout(function() {
            me.$scrollTopTarget.removeClass('hide-header');
          }, me.scrollSpeed);
        });

        me.$pageAnchor.on('click', function() {
          if (containsHashParameters(this.hash)) {
            return;
          }

          var target = $(this.hash);
          if (target.length !== 0) {
            me.animateScroll(target);
          }

          function containsHashParameters(hash) {
            return hash.indexOf('&') >= 0 || hash.indexOf('=') >= 0;
          }
        });
      }
    };

    new ScrollHandler({
      scrollSpeed: 1000,
      scrollToShowMenu: 500,
      $scrollTopControl: $('#scroll2top'),
      $scrollTopTarget: $('.lc-header-section'),
      $pageAnchor: $('a[href*=\\#]:not([href=\\#])'),
      topWrapperHeight: getMessageBarHeightIfVisible() + $('#topBar').height(),
      $pageHeader: $('#header'),
      $pageWrapper: $('#container')
    });

    blankshield(document.querySelectorAll('a[target=_blank]'));
  },

  loadImageFailed: function(elem) {
    elem.src =
      'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
  }
};

(function($) {
  $(document).ready(function() {
    imat.UILayout.init($);
  });
})(jQuery);
